import React from 'react'

// general imports
import { IconPropsType } from '../types'

const NewCheckIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='96'
      height='96'
      className={className}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='48' cy='48' r='48' fill='#27B524' fillOpacity='0.1' />
      <circle cx='48' cy='48' r='26' fill='#029E31' />
      <path
        d='M58.6663 40L43.9997 54.6667L37.333 48'
        stroke='white'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default NewCheckIcon
